var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-container"},[_c('f7-navbar',{staticClass:"popup-navbar"},[_c('f7-nav-left',{staticClass:"nav-left"},[_c('f7-link',{staticClass:"nav-icon",on:{"click":function($event){return _vm.$emit("close")}}})],1),_c('f7-nav-title',[_vm._v(_vm._s(_vm.title))]),_c('f7-nav-right'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }